import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface TicketLifecycleMetadata {
  showModal: boolean;
  ticketId?: string;
  summonsNumber?: string;
}

interface TicketLifecycleState {
  metadata: TicketLifecycleMetadata;
}

const initialState: TicketLifecycleState = {
  metadata: { showModal: false }
};

export const ticketLifecycleSlice = createSlice({
  name: 'ticketLifecycle',
  initialState: { ...initialState },
  reducers: {
    showTicketLifecycle: (
      state,
      action: PayloadAction<{ ticketId: string; summonsNumber: string }>
    ) => {
      state.metadata = {
        showModal: true,
        ticketId: action.payload.ticketId,
        summonsNumber: action.payload.summonsNumber
      };
    },
    hideTicketLifecycle: (state) => {
      state.metadata = { showModal: false };
    },
    clearTicketLifecycleSlice: () => {
      return initialState;
    }
  }
});

export const { showTicketLifecycle, hideTicketLifecycle, clearTicketLifecycleSlice } =
  ticketLifecycleSlice.actions;

export default ticketLifecycleSlice.reducer;
